import { ZAttribute } from "src/types/ZAttribute";
import { ZAttrLabelTreeData } from "../types/ZAttrLabelTreeData";

export const getAttrLabelTreeData = (
  attribute: ZAttribute,
  labelTreeData: ZAttrLabelTreeData[],
) => {
  const treeDataIdMap = new Map(labelTreeData?.map((d) => [d.attrId, d]));
  return treeDataIdMap.get(attribute.id);
};
